import { render, staticRenderFns } from "./TaxonomyForm.vue?vue&type=template&id=6a0e5151&lang=pug"
import script from "./TaxonomyForm.vue?vue&type=script&lang=js"
export * from "./TaxonomyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports